import { render, staticRenderFns } from "./ItemCardView.vue?vue&type=template&id=a87ffa0e"
import script from "./ItemCardView.vue?vue&type=script&lang=js"
export * from "./ItemCardView.vue?vue&type=script&lang=js"
import style0 from "./ItemCardView.vue?vue&type=style&index=0&id=a87ffa0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports